import { ScrollArea, Table, Title } from '@mantine/core';
import { GrandSlamUser, WinterSlamUser } from 'firebaseNextjs/models';
import { TableMatchPoints } from 'pages/events/winterslam';
import { useEffect, useState } from 'react';

const DIV_CLASS = ['ma', 'ex', 'ss', 'mm', 'nv', 'un'];
const ALL_DIVISION = ['pcc', 'co', 'ssp', 'esp', 'cdp', 'ccp', 'rev', 'bug'];
const ALL_SUBCAT = ['senior', 'distinguished senior', 'lady'];

export default function GrandSlamTable({
  elements,
  title,
  global,
  categories,
}: {
  elements: GrandSlamUser[] | TableMatchPoints[];
  title: string;
  global: boolean;
  categories: boolean;
}) {
  const [extended, setExtended] = useState(false);
  useEffect(() => {
    if ('shooterBehind' in elements[0]) {
      setExtended(true);
    }
  }, []);
  const shooters = elements.reduce((p: any, c: any) => {
    if (c.division === 'nfc') {
      return p;
    }
    if (!p[c.division]) {
      // eslint-disable-next-line no-param-reassign
      p[c.division] = [];
    }
    if (!p[c.division][c.class]) {
      // eslint-disable-next-line no-param-reassign
      p[c.division][c.class] = [];
    }
    p[c.division][c.class].push(c);
    return p;
  }, {});
  const rows = (division: string) => {
    const elementsTable: Array<any> = [];
    DIV_CLASS.forEach((idpaClass: string) => {
      if (shooters[division][idpaClass]) {
        elementsTable.push(
          ...shooters[division][idpaClass].sort(
            (a: WinterSlamUser, b: WinterSlamUser) => b.pointsTotal - a.pointsTotal
          )
        );
      }
    });
    return elementsTable.sort(
      (a: WinterSlamUser, b: WinterSlamUser) => b.pointsTotal - a.pointsTotal
    ).map((element) => (
      <tr key={element.id}>
        <td style={{ textTransform: 'capitalize' }}>{element.name}</td>
        <td>{element.class}</td>
        <td>{element.division}</td>
        {extended && (
          <>
            <td>{element.rankingDivision >= 0 ? element.rankingDivision + 1 : ''}</td>
            <td>{element.rankingClass}</td>
            <td>{element.shooterBehind}</td>
            <td>{element.pointsRanking}</td>
            <td>{element.pointsMatch}</td>
          </>
        )}
        <td>{element.pointsTotal}</td>
        <td>{element.pd}</td>
        {global && (
          <>
            <td>{element.matchesPoints.defense || '-'}</td>
            <td>{element.matchesPd.defense || '-'}</td>
            <td>{element.matchesPoints.conrad || '-'}</td>
            <td>{element.matchesPd.conrad || '-'}</td>
            <td>{element.matchesPoints.fullprotection || '-'}</td>
            <td>{element.matchesPd.fullprotection || '-'}</td>
            <td>{element.matchesPoints.agna || '-'}</td>
            <td>{element.matchesPd.agna || '-'}</td>
            <td>{element.matchesPoints.tps || '-'}</td>
            <td>{element.matchesPd.tps || '-'}</td>
            {/* <td>{element.matchesPoints.Broni || '-'}</td> */}
          </>
        )}
      </tr>
    ));
  };

  const rowsCategories = (category: string) => {
    const elementsTable: Array<any> = [];
    ALL_DIVISION.forEach((division) => {
      DIV_CLASS.forEach((idpaClass: string) => {
        if (shooters[division][idpaClass]) {
          elementsTable.push(
            ...shooters[division][idpaClass].filter(
              (shooter: TableMatchPoints) => shooter?.category?.includes(category)
            )
          );
        }
      });
    });
    return elementsTable
      .sort((a: WinterSlamUser, b: WinterSlamUser) => b.pointsTotal - a.pointsTotal)
      .map((element) => (
        <tr key={element.id}>
          <td style={{ textTransform: 'capitalize' }}>{element.name}</td>
          <td>{element.class}</td>
          <td>{element.division}</td>
          {extended && (
            <>
              <td>{element.rankingDivision >= 0 ? element.rankingDivision + 1 : ''}</td>
              <td>{element.rankingClass}</td>
              <td>{element.shooterBehind}</td>
              <td>{element.pointsRanking}</td>
              <td>{element.pointsMatch}</td>
            </>
          )}
          <td>{element.pointsTotal}</td>
          <td>{element.pd}</td>
          {global && (
            <>
              <td>{element.matchesPoints.defense || '-'}</td>
              <td>{element.matchesPd.defense || '-'}</td>
              <td>{element.matchesPoints.conrad || '-'}</td>
              <td>{element.matchesPd.conrad || '-'}</td>
              <td>{element.matchesPoints.fullprotection || '-'}</td>
              <td>{element.matchesPd.fullprotection || '-'}</td>
              <td>{element.matchesPoints.agna || '-'}</td>
              <td>{element.matchesPd.agna || '-'}</td>
              <td>{element.matchesPoints.tps || '-'}</td>
              <td>{element.matchesPd.tps || '-'}</td>
              {/* <td>{element.matchesPoints.Broni || '-'}</td> */}
            </>
          )}
        </tr>
      ));
  };

  const headTable = () => (
    <thead>
      <tr>
        <th>Nome</th>
        <th>Classe</th>
        <th>Divisione</th>
        {extended && (
          <>
            <th>Posizione Divisione</th>
            <th>Posizione Classe</th>
            <th>Shooter Battuti</th>
            <th>Punteggio Ranking</th>
            <th>Punti Match Parziali</th>
          </>
        )}
        <th>Punti Match Totali</th>
        <th>Punti Down Totali</th>
        {global && (
          <>
            <th>Punti Match Arcisate</th>
            <th>PD Arcisate</th>
            <th>Punti Match Conrad</th>
            <th>PD Conrad</th>
            <th>Punti Match Full Protection</th>
            <th>PD Full Protection</th>
            <th>Punti Match Phalanx Agna</th>
            <th>PD Phalanx Agna</th>
            <th>Punti Match TPS</th>
            <th>PD TPS</th>
            {/* <th>Punti Match Gornate</th>
            <th>Punti Match Broni</th> */}
          </>
        )}
      </tr>
    </thead>
  );

  return (
    <>
      <Title align="center" order={2} mb={40}>
        {title}
      </Title>
      <ScrollArea type="auto">
        {!categories &&
          ALL_DIVISION.map((division) => (
            <>
              <Title order={2} italic color="blue.5">
                Divisione {division.toUpperCase()}
              </Title>
              <Table striped highlightOnHover mb={30}>
                {headTable()}
                <tbody>{rows(division)}</tbody>
              </Table>
            </>
          ))}
        {categories &&
          ALL_SUBCAT.map((category) => (
            <>
              <Title order={2} italic color="blue.5">
                {category.toUpperCase()}
              </Title>
              <Table striped highlightOnHover mb={30}>
                {headTable()}
                <tbody>{rowsCategories(category)}</tbody>
              </Table>
            </>
          ))}
      </ScrollArea>
    </>
  );
}
